export function init() {
  $(document).ready(function () {

    function updateUrl(data) {
      const baseUrl = window.location.href.split('?')[0];
      const queryString = $.param(data);
      return baseUrl + '?' + queryString;
    }

    function getData() {
      const sortValue = $('.select-category').val();
      const selectedPrice = $('.radio-price:checked').val();
      const selectedDiscount = $('.radio-discount:checked').val();

      const requestData = {
        sort: sortValue,
        price: selectedPrice,
        discount: selectedDiscount,
      };

      window.location.href = updateUrl(requestData);
    }

    $('.radio-price').change(function () {
      showLoading();
      getData();
    });

    $('.radio-discount').change(function () {
      showLoading();
      getData();
    });

    $('.select-category').change(function () {
      showLoading();
      getData();
    });

    $('.show-more-category').click(function () {
      const isExpanded = $(this).attr('aria-expanded') === 'true';
      if (isExpanded) {
        $(this).html('Thu gọn');
      } else {
        $(this).html('Xem thêm');
      }
    });

    $('.category').click(function () {
      showLoading();
    });

    $('.heart-push-login-btn').click(function () {
      $('#login-popup').modal('show');
    })

    function showLoading() {
      $('.products').html(`
        <div id="loading" class="d-flex justify-content-center mt-5 py-5">
          <div class="spinner-border text-success" role="status">
            <span class="visually-hidden">Loading...</span>
          </div>
        </div>
      `);
    }
  });
}
